exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.merge-tooltip[data-v-09c92ba2] {\n    position: absolute;\n    left: 50%;\n    bottom: 100%;\n    transform: translate(-50%, -15px);\n}\n", ""]);

// exports
